import classNames from 'classnames'
import { useRouter } from 'next/router'

const BlogMobileCategorySection = ({ categoryList, selected, setSelected }) => {
  const router = useRouter()

  const handleCategory = (listItem) => {
    const { query } = router
    router.push(
      {
        pathname: router.pathname,
        query: {
          ...query,
          category: listItem._id,
          subcategory: undefined, // 카테고리 변경 시 서브카테고리 초기화
        },
      },
      undefined,
      { shallow: true }
    )
    setSelected(listItem)
  }

  return (
    <div className={style.categorySectionWrapper}>
      <div className="sticky top-[61px] ml-[20px] mr-[120px] flex w-screen flex-row gap-[16px] ">
        {categoryList.map((listItem, i) => {
          return (
            <div
              key={i}
              className={classNames('', {
                'pr-[32px]': categoryList.length == i + 1,
              })}
            >
              <button
                className={style.categorySectionItem(listItem._id === selected?._id)}
                onClick={() => handleCategory(listItem)}
              >
                {listItem.title}
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default BlogMobileCategorySection

const style = {
  categorySectionWrapper: `border-b-1 no-scrollbar sticky top-[0px] z-10 h-[54px] w-full overflow-y-hidden overflow-x-scroll  border-gray-100 bg-[rgba(255,255,255,0.85)] backdrop-blur-[5px]`,
  categorySectionItem: (isSelected) =>
    isSelected
      ? `Body1-16Bd border-separate whitespace-nowrap border-b-2 border-b-black px-[8px] pt-[13px] pb-[13px]`
      : `Body1-16Bd whitespace-nowrap px-[8px] py-[13px] text-gray-300 `,
}
